import { render, staticRenderFns } from "./IcoBookGraph.vue?vue&type=template&id=47c3df01"
import script from "./IcoBookGraph.vue?vue&type=script&lang=js"
export * from "./IcoBookGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports